import { Component, Input, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseModalComponent } from './base-modal.component';

export interface ExpenseModalData {
  specification: string;
  date: string;
  start_date_time?: string;
  end_date_time?: string;
  type: string;
  total: number;
  vat?: number;
  exclVat?: number;
  participants?: string;
  distance_km?: number;
  km_reimbursement?: number;
  receipts: string[];
}

export interface ExpenseDialogData {
  expense: ExpenseModalData;
  headerText?: string;
  actionButtonText?: string;
}

@Component({
  selector: 'expense-modal',
  standalone: true,
  imports: [CommonModule],
  template: require('./expense-modal.component.html').default,
  styles: [require('!!raw-loader!sass-loader!./expense-modal.component.scss').default],
})
export class ExpenseModalComponent extends BaseModalComponent {
  @Input() expense?: ExpenseModalData;
  @Input() headerText: string = 'Information';
  @Input() actionButtonText: string = 'Stäng';

  previewImage: string | null = null;
  currentImageIndex: number = 0;
  isZoomed: boolean = false;

  constructor() {
    super();
  }

  configure(config: ExpenseDialogData) {
    if (config.expense) this.expense = config.expense;
    if (config.headerText) this.headerText = config.headerText;
    if (config.actionButtonText) this.actionButtonText = config.actionButtonText;
  }

  openPreview(index: number) {
    if (this.expense && this.expense.receipts && this.expense.receipts[index]) {
      this.currentImageIndex = index;
      this.previewImage = this.expense.receipts[index];
      this.isZoomed = false; // Reset zoom on open
    }
  }

  nextImage(event?: Event) {
    if (event) event.stopPropagation();
    if (this.expense && this.expense.receipts) {
      this.currentImageIndex = (this.currentImageIndex + 1) % this.expense.receipts.length;
      this.previewImage = this.expense.receipts[this.currentImageIndex];
      this.isZoomed = false;
    }
  }

  prevImage(event?: Event) {
    if (event) event.stopPropagation();
    if (this.expense && this.expense.receipts) {
      this.currentImageIndex = (this.currentImageIndex - 1 + this.expense.receipts.length) % this.expense.receipts.length;
      this.previewImage = this.expense.receipts[this.currentImageIndex];
      this.isZoomed = false;
    }
  }

  closePreview() {
    this.previewImage = null;
    this.isZoomed = false;
  }

  toggleZoom(event: MouseEvent) {
    event.stopPropagation(); // Don't close preview when clicking image
    this.isZoomed = !this.isZoomed;
  }

  onBackdropClick(event: MouseEvent) {
    if ((event.target as HTMLElement).classList.contains('modal')) {
      this.close();
    }
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.previewImage) {
      // Navigation
      if (event.key === 'ArrowRight') {
        this.nextImage();
        event.preventDefault();
        event.stopImmediatePropagation();
      } else if (event.key === 'ArrowLeft') {
        this.prevImage();
        event.preventDefault();
        event.stopImmediatePropagation();
      } else if (event.key === 'Escape') {
        this.closePreview();
        event.preventDefault();
        event.stopImmediatePropagation();
      } 
      // Block scrolling keys from affecting background
      else if (['ArrowUp', 'ArrowDown', ' ', 'PageUp', 'PageDown', 'Home', 'End'].includes(event.key)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }
  }
}
